import React from 'react';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '../config/constants';

export const Footer: React.FC = () => {
  const handleSocialClick = (platform: string) => {
  };

  const handleLinkClick = () => {
    // Remonter en haut de la page lors du clic sur un lien
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-800 text-white py-12 mt-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">{APP_CONFIG.name}</h3>
            <p className="text-gray-300 mb-4">
              {APP_CONFIG.tagline}
            </p>
            <div className="flex space-x-4">
              <button 
                onClick={() => handleSocialClick('Facebook')}
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </button>
              <a 
                href="https://www.instagram.com/ae.heg/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Instagram AEHEG"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <button 
                onClick={() => handleSocialClick('LinkedIn')}
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">Accueil</Link></li>
              <li><Link to="/tutors" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">Tuteur-trices</Link></li>
              <li><Link to="/signup" onClick={handleLinkClick} className="text-green-400 hover:text-green-300 transition-colors font-semibold">Devenir tuteur-trice</Link></li>
              <li><Link to="/contact" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/faq" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/aide" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">Support</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Légal</h4>
            <ul className="space-y-2">
              <li><Link to="/aide" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">Centre d'aide</Link></li>
              <li><Link to="/conditions" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">Conditions d'utilisation</Link></li>
              <li><Link to="/confidentialite" onClick={handleLinkClick} className="text-gray-300 hover:text-white transition-colors">Politique de confidentialité</Link></li>
            </ul>
            
            <div className="mt-6">
              <h5 className="text-md font-semibold mb-3">Contact</h5>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-gray-300">
                  <i className="fas fa-envelope text-sm"></i>
                  <a href={`mailto:${APP_CONFIG.supportEmail}`} className="text-sm hover:text-white transition-colors">
                    {APP_CONFIG.supportEmail}
                  </a>
                </div>
                <div className="flex items-center gap-2 text-gray-300">
                  <i className="fas fa-map-marker-alt text-sm"></i>
                  <span className="text-sm">HEG-Genève, Carouge</span>
                </div>
              </div>
              <div className="mt-4">
                <Link
                  to="/contact"
                  onClick={handleLinkClick}
                  className="inline-flex items-center gap-2 bg-[#002c46] text-white px-4 py-2 rounded-lg hover:bg-[#001a2a] transition-colors text-sm font-medium"
                >
                  <i className="fas fa-paper-plane"></i>
                  Nous contacter
                </Link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}; 